import { createStore } from 'effector';
import { $authUserId } from '~/entities/auth';
import { alwaysNew } from '~/shared/lib/alwaysNew';
import { setNewTicketsCount } from './events';

export const $newTicketsCount = createStore<number | null>(null)
    .on(setNewTicketsCount, alwaysNew)
    .reset($authUserId.updates);
